<template>
  <div class="home-column" :class="classes" @click="setActive(true, $event)">
    <div class="semi-icon">
      <icon :name="icon"/>
    </div>
    <div class="header">
      <div class="icon">
        <icon :name="icon"/>
      </div>
      <h3>{{ title }}</h3>
      <div class="click">
        <icon name="hand-pointer"/> Click to see more
      </div>
    </div>
    <div class="content" :class="{ fastTransition }">
      <p v-for="(text, index) in texts" :key="index">{{ text }}</p>
    </div>
    <div class="close" @click="setActive(false, $event)">
      <icon name="cross"/>
    </div>
    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
  props: ['icon', 'index', 'texts', 'title'],
  data() {
    return {
      active: false,
      fastTransition: false,
    }
  },
  computed: {
    classes() {
      const dataClasses = { active: this.active, fastTransition: this.fastTransition }
      const classes = Object
        .keys(dataClasses)
        .filter(key => dataClasses[key])

      return [...classes, `step-${this.index}`]
    },
  },
  methods: {
    setActive(val, ev) {
      if (val) {
        if (!this.active && !['i-cross', 'close'].includes(ev.target.className)) {
          this.active = true
          setTimeout(() => {
            this.fastTransition = true
          }, 1000)
        }
      } else {
        this.active = false
        setTimeout(() => {
          this.fastTransition = false
        }, 400)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

section.features {
  background: #fff;
  box-shadow: 0 -5px 10px rgba(0,0,0,0.1);
  height: 240px;
  margin-bottom: 2rem;
  padding: 0;
  position: relative;
  @media screen and (max-width: $res-sm) {
    height: 960px;
  }
  @media screen and (min-width: ($res-sm + 1px)) and (max-width: $res-md) {
    height: 480px;
  }
  > .wrap {
    position: relative;
    height: 100%;
  }
  > .overlay {
    position: absolute;
    background: $c-grey;
    width: 100%;
    bottom: 0;
    height: 5px;
    z-index: 1;
  }
}

.home-column {
  background: #fff;
  border-right: 1px solid $c-grey;
  cursor: pointer;
  float: left;
  height: 240px;
  overflow: hidden;
  position: absolute;
  transform: skewX(-10deg);
  transition: all 0.5s cubic-bezier(0.69, 0.12, 0.03, 1.53);
  width: 25%;
  z-index: 2;
  -webkit-backface-visibility: hidden; // fix sharp edges
  .header {
    transform: skewX(10deg);
    position: relative;
    transition: all 0.4s 0.5s ease-in-out, padding 0.4s 0.1s ease-in-out, color 0.4s ease-in-out;
    padding: 3rem 1rem 0 0;
    text-align: center;
    width: 100%;
    float: left;
    z-index: 4;
    .icon {
      font-size: $h1;
      height: 100px;
      opacity: 1;
      pointer-events: none;
      transition: all 0.4s 0.2s ease-in-out;
    }
    h3 {
      color: inherit;
      font-size: $h4;
      // line-height: 1.9rem;
      text-transform: uppercase;
    }
    .click {
      bottom: 0;
      color: #fff;
      font-size: $h6;
      opacity: 0;
      padding-right: 3rem;
      pointer-events: none;
      position: absolute;
      transition: all 0.4s 0.3s ease-in-out;
      width: 100%;
    }
  }
  .semi-icon {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 256px;
    color: rgba(255,255,255,0);
    transition: all 0.6s 0.3s cubic-bezier(.69,.12,.1,1.89);
    z-index: 3;
    pointer-events: none;
  }
  .overlay {
    background: $c-grey;
    position: absolute;
    width: 101%;
    height: 100%;
    left: 0;
    top: 98%;
    transition: all 0.4s ease-in-out;
    z-index: 2;
  }
  .content {
    visibility: hidden;
    position: relative;
    padding: 2rem 3rem 0 0.5rem;
    transition: all 0.3s 0.8s linear;
    transform: skewX(10deg);
    text-align: justify;
    float: left;
    z-index: 4;
    width: 74.95%;
    color: #fff;
    opacity: 0;
    p {
      font-size: $h3;
    }
  }
  .close {
    position: absolute;
    transform: skewX(10deg);
    visibility: hidden;
    cursor: pointer;
    color: #fff;
    top: 2rem;
    right: 2rem;
    z-index: 4;
  }
  &.active {
    width: 100%;
    left: 0 !important;
    z-index: 10;
    cursor: default;
    .header {
      width: 24.95%;
    }
    .close {
      visibility: visible;
    }
    .content {
      visibility: visible;
      opacity: 1;
    }
    .click {
      opacity: 0 !important;
    }
  }
  &.fastTransition {
    .header {
      transition: color 0.5s 0.5s ease-in-out;;
    }
    .content {
      transition: none;
    }
  }
  &:hover, &.active, &.hover {
    border-right-color: transparent;
    margin-top: -2rem;
    .semi-icon {
      color: rgba(255,255,255,0.07);
    }
    .overlay {
      top: 0;
    }
    .header {
      padding-top: 3rem;
      color: #fff;
      .icon {
        color: #fff;
      }
    }
  }
  &:hover {
    .header .click {
      bottom: -32px;
      opacity: 1;
    }
  }
  &.step-0 {
    left: 0;
    .icon {
      color: $c-green;
    }
    .overlay {
      background: $c-green;
    }
  }
  &.step-1 {
    left: 25%;
    .icon {
      color: $c-blue;
    }
    .overlay {
      background: $c-blue;
    }
  }
  &.step-2 {
    left: 50%;
    .icon {
      color: $c-red;
    }
    .overlay {
      background: $c-red;
    }
  }
  &.step-3 {
    left: 75%;
    .icon {
      color: $c-fancy;
    }
    .overlay {
      background: $c-fancy;
    }
  }
  @media screen and (max-width: $res-sm) {
    width: 100%;
    transform: none;
    .header {
      transform: none;
      font-size: 2.5rem;
    }
    .close {
      transform: none;
    }
    .content {
      padding: 3rem 0 0 1rem;
      transform: none;
      p {
        font-size: $h3;
      }
    }
    &.active {
      .header {
        visibility: hidden;
        width: 0%;
      }
    }
    &.step-1 {
      top: 25%;
      left: 0;
    }
    &.step-2 {
      top: 50%;
      left: 0;
    }
    &.step-3 {
      top: 75%;
      left: 0;
    }
  }
  @media screen and (min-width: ($res-sm + 1px)) and (max-width: $res-md) {
    width: 50%;
    transform: none;
    .header {
      transform: none;
    }
    .close {
      transform: none;
    }
    .content {
      padding: 2rem 0 0 0.5rem;
      transform: none;
      width: 91%;
      p {
        font-size: $h3;
      }
    }
    &.active {
      .header {
        visibility: hidden;
        width: 0%;
      }
    }
    &.step-1 {
      left: 50%;
    }
    &.step-2 {
      top: 50%;
      left: 0;
    }
    &.step-3 {
      top: 50%;
      left: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/Feature.vue